module.exports = __webpack_public_path__ + "6aab444aa078a8beb028d89387ab967a.svg";